export default __webpack_public_path__ + "static/media/pos.f65b586c.png";